// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__3BxVG","top":"style_top__2z5wM","title":"style_title__11FRE","text":"style_text__3yAg5"};